<template>
  <div class="panel">

    <!-- Cartel de advertencia mala ponderación -->
    <div v-if="hasWeightingError" class="flex items-center justify-between w-full mb-4">
      <div class="text-lg font-semibold uppercase text-red-light">
        {{ $t("weighting_not_100") }}
      </div>
    </div>

    <!-- Título -->
    <div class="flex items-center justify-between w-full mb-4">
      <div class="text-lg font-thin uppercase text-blue-light">
        {{ titleLabel }}
      </div>
    </div>

    <!-- <div v-if="isLoading" class="my-4 text-center">
      <scale-loader />
    </div>
    <div v-else> -->
      <div class="w-full">
        <b-tabs type="is-boxed" v-model="mainActiveTab">

          <!-- Resource -->
          <b-tab-item v-if="pictogramId == null">

            <template #header>
                  <span> {{ resourcesLabel }}
                    <b-icon v-show="isLoadingResource"
                      pack="fas"
                      icon="spinner"
                      class="fa-pulse"
                      size="is-small">
                    </b-icon>
                    <b-tag v-show="!isLoadingResource" rounded class="font-semibold"> {{ listResources.length }} </b-tag> </span>
            </template>

            <div class="w-full">

              <div class="flex flex-row justify-between text-sm uppercase align-middle text-blue-light">
                <div>
                  <b-button
                    @click="onClickUnlockMeasurementsButton"
                    @reload="() => reload()"
                    v-if="canManageCertifiers && listResources.length"
                    type="is-small is-primary"
                    class="font-semibold uppercase">
                      <span v-if="assignmentsLocked">{{ $t("unlock_measurements") }}</span>
                      <span v-else>{{ $t("lock_measurements") }}</span>
                  </b-button>
                </div>

                <b-field v-if="listResources.length">
                  <b-tag v-if="assignmentsLocked" type="is-success">
                      <span>{{ $t('blocked') }}</span>
                  </b-tag>
                  <b-tag v-else type="is-warning">
                      <span>{{ $t('unlocked') }}</span>
                  </b-tag>
                </b-field>

                <div>
                  <b-button
                    @click="addResourceButtonClicked"
                    @reload="() => reload()"
                    v-if="canAdd"
                    :disabled="!canEditAssignments()"
                    type="is-small is-primary"
                    class="font-semibold uppercase">{{ $t("add_resource") }}</b-button>
                  <b-button
                    @click="editResourcesButtonClicked"
                    @reload="() => reload()"
                    v-if="canAdd"
                    :disabled="!canEditAssignments()"
                    type="is-small is-primary"
                    class="font-semibold uppercase">
                    {{ isEditing ? $t("cancel") : $t("edit")  }} {{ isEditing ? null : $t("resource") }}
                  </b-button>
                </div>
              </div>

              <div v-if="isLoadingResource" class="my-4 text-center">
                <scale-loader />
              </div>

              <div v-else class="flex flex-row justify-between mt-3 text-sm uppercase align-middle text-blue-light">
                <div>
                  <span v-if="listResources.length" class="font-semibold">{{ listResources.length }}</span> {{ !listResources.length ? $t("no_resources_found") : $t("resources_under_execution") }}
                  <!-- aqui mostramos el todal de ponderacion la suma de todos los recursos -->
                  <span v-if="isEditing" class="font-semibold text-red-light">total ponderacion {{ calculePonderation() }} </span>
                </div>
                <b-button
                    @click="onSaveEditedResources"
                    @reload="() => reload()"
                    v-if="canAdd && isEditing"
                    :disabled="!canEditAssignments() || calculePonderation() !== 100.00"
                    type="is-small is-success"
                    :loading="editingLoading"
                    class="font-semibold uppercase">{{ $t("save") }}</b-button>
              </div>
            </div>

            <!-- Tabla de Recursos/tareas -->
            <div class="flex items-center my-4" v-if="!isLoadingResource && listResources.length">
              <table class="w-full">
                <thead class="bg-blue-lightest">
                  <tr>
                    <th class="p-2 text-sm font-semibold text-center uppercase text-blue-dark"></th>
                    <th class="p-2 text-sm font-semibold uppercase text-blue-dark">{{ $t("resource") }}</th>
                    <th class="p-2 text-sm font-semibold uppercase text-blue-dark">{{ $t("interval") }}</th>
                    <th class="p-2 text-sm font-semibold uppercase text-blue-dark">{{ $t("progress_inspected_label") }}</th>
                    <th class="p-2 text-sm font-semibold uppercase text-blue-dark" v-if="canRecordActualprogress">{{ $t("actual_progress") }}</th>
                    <th class="p-2 text-sm font-semibold uppercase text-blue-dark"></th>
                  </tr>
                </thead>

                <tbody>
                  <template v-for="row in listResources">

                    <!-- Recorremos los recursos -->
                    <tr class="hover:bg-grey-lightest" :key="row.id">

                      <!-- Icono Detalles / Historia -->
                      <td class="justify-start w-auto h-full p-4 align-middle">

                        <div v-if="row.lines && row.lines.length && !hideHistoryLines()"
                          class="flex text-center align-middle cursor-pointer" @click="displayHistory(row.id)">
                          <b-tooltip
                            :label="$t('display_history',[row.lines.length])"
                            position="is-right"
                          >
                            <span class="mr-1 text-xs font-semibold text-blue">{{ row.lines.length }}</span>
                            <b-icon icon="history" pack="fas" size="is-small" class="mr-1 text-blue"></b-icon>
                            <b-icon :icon=" (row.id == selectedHistory) ? 'chevron-up' : 'chevron-down'" pack="fas" size="is-small" class="text-blue"></b-icon>
                          </b-tooltip>
                        </div>
                        <div v-else-if="row.children_count > 0"
                        class="flex text-center align-middle cursor-pointer" @click="displayDetails(row)">
                          <b-tooltip
                            :label="$t('display_details',[row.children_count])"
                            position="is-right"
                            >
                            <span class="mr-1 text-xs font-semibold text-blue">{{ row.children_count }}</span>
                            <b-icon icon="list" pack="fas" size="is-small" class="mr-1 text-blue"></b-icon>
                            <b-icon :icon=" (row.id == selected) ? 'chevron-up' : 'chevron-down'" pack="fas" size="is-small" class="text-blue"></b-icon>
                          </b-tooltip>
                        </div>
                      </td>

                      <!-- Titulo / Peso -->
                      <td class="p-2" >
                        <div class="flex flex-row items-center">
                          <div class="w-2 h-2 mr-1 rounded-full bg-green" v-if="row.completed"></div>
                          <div class="text-xs font-semibold">{{ row.name }}</div>
                        </div>
                        <div class="text-xs text-blue"><span class="font-semibold">{{ $t('resource_weight_msg', [formatWeight(row.weight)]) }}</span></div>

                        <div v-if="row.order">
                          <span class="text-xs">Sub.:</span> <span class="inline-flex items-center rounded-md bg-blue-50 px-2 py-1 text-xs font-medium text-blue-700 ring-1 ring-inset ring-blue-700/10">{{ getNameOrCodePartner(row.order.partners) }}</span>
                        </div>


                      </td>

                      <!-- Fechas / Plazo-->
                      <td class="p-2">
                        <div class="flex flex-col" v-if="row.start_date != null">
                          <div class="text-xs">{{ $t('resource_date_interval', [moment(row.start_date).format('DD/MM/YYYY'), moment(row.end_date).format('DD/MM/YYYY')]) }}</div>
                          <div class="flex flex-row items-center" v-if="row.end_date > realEndDate">
                            <div class="w-2 h-2 rounded-full bg-red"></div>
                            <div class="ml-1 text-xs font-medium text-red">{{ $t('activity_time_status_danger') }}</div><!-- fuera de plazo -->
                          </div>
                          <div class="flex flex-row items-center" v-else>
                            <div class="w-2 h-2 rounded-full bg-green"></div>
                            <div class="ml-1 text-xs font-medium text-green">{{ $t('activity_time_status_ok') }}</div><!-- en plazo -->
                          </div>
                        </div>
                        <div class="flex flex-col" v-else>
                          <div class="text-xs" >{{ $t('not_started') }}</div><!-- sin iniciar -->
                          <div class="flex flex-row items-center">
                            <div class="w-2 h-2 rounded-full bg-grey"></div>
                            <div class="ml-1 text-xs font-medium text-grey">{{ $t('pending_execution') }}</div><!-- pendiente de ejecutar -->
                          </div>
                        </div>
                        <div v-if="isEditing" class="flex flex-col">
                          <b-field label="Ponderación" label-position="inside">
                            <b-input
                              v-model="row.weight"
                              type="number"
                              min="0"
                              max="100"
                              step="0.01"
                              :disabled="!canEditAssignments()"
                              @input="onEditResource(row, 'weight')"
                            ></b-input>
                          </b-field>
                        </div>
                      </td>

                      <!-- Pendiente / Ejecutado -->
                      <td class="p-2">
                        <div class="flex flex-col">
                          <div class="text-xs text-grey-dark">{{ formatPendingDisplay(row) }} {{ row.unit.code }} {{ $t('pendings') }}</div>
                          <div class="text-xs font-medium text-blue">{{ formatExecutedDisplay(row) }} / {{ formatTotalDisplay(row) }} {{ row.unit.code }} {{ $t('executed') }}</div>

                          <div class="text-xs font-medium text-orange" v-if="row.pending_validation_quantity">{{ formatAssignmentQuantity(row.pending_validation_quantity, row) }} {{ row.unit.code }} {{ $t('pending_validation_quantity').toLowerCase() }}</div>

                          <div class="text-xs font-medium text-orange" v-if="project.has_quality_validation && row.pending_quality_validation_quantity">{{ formatAssignmentQuantity(row.pending_quality_validation_quantity, row) }} {{ row.unit.code }} {{ $t('pending_quality_validation_quantity').toLowerCase() }}</div>

                        </div>
                        <div v-if="isEditing" class="flex flex-col">
                          <b-field label="Total Unidades" label-position="inside">
                            <b-input
                              v-model="row.total_units"
                              type="number"
                              min="0"
                              step="0.01"
                              :disabled="!canEditAssignments()"
                              @input="onEditResource(row, 'total_units')"
                            ></b-input>
                          </b-field>
                        </div>
                      </td>
                      <!-- Pendiente / Ejecutado actual progress-->
                      <td class="p-2" v-if="canRecordActualprogress">
                        <div class="flex flex-col">
                          <div class="text-xs text-grey-dark">{{ formatPendingDisplay(row, 'actual_progress') }} {{ row.unit.code }} {{ $t('pendings') }}</div>
                          <div class="text-xs font-medium text-blue">{{ formatExecutedDisplay(row, 'actual_progress') }} / {{ formatTotalDisplay(row) }} {{ row.unit.code }} {{ $t('executed') }}</div>
                        </div>
                      </td>

                      <!-- Opciones -->
                      <td class="justify-center w-auto h-full p-4 align-middle">
                        <div class="text-center cursor-pointer">
                          <b-dropdown aria-role="list" position="is-bottom-left">

                            <template #trigger="{ active }">
                                <b-icon :icon="active ? 'ellipsis-h' : 'ellipsis-v'" pack="fas" size="is-small" class="text-blue"></b-icon>
                            </template>
                            <b-dropdown-item aria-role="listitem" @click="onNameClick(row, true)" v-if="row.children_count == 0 && !row.completed && canRecordActualprogress" >
                              <span class="text-xs">{{ $t('actual_progress') }}</span>
                            </b-dropdown-item>
                            <!-- medicion padre, accion mostrar hijos -->
                            <b-dropdown-item aria-role="listitem" v-if="row.children_count > 0 && !row.completed"
                              @click="displayDetails(row)">
                              <span class="text-xs text-orange-600">{{ registerProgressLabel(row) }}</span>
                            </b-dropdown-item>
                            <!-- medicion sin hijos, accion registrar progreso -->
                            <b-dropdown-item aria-role="listitem" v-else-if="row.children.length == 0 && !row.completed"
                              @click="onNameClick(row)">
                              <span class="text-xs">{{ registerProgressLabel(row) }}</span>
                            </b-dropdown-item>
                            <b-dropdown-item v-if="row.lines == null" aria-role="listitem" @click="addSubResource(row)" :disabled="!canEditAssignments()">
                              <span class="text-xs">{{ $t('add_subresource') }}</span>
                            </b-dropdown-item>
                            <b-dropdown-item v-if="!row.completed" aria-role="listitem" @click="onClickEdit(row)" :disabled="!canEditAssignments()">
                              <span class="text-xs">{{ $t('edit') }}</span>
                            </b-dropdown-item>
                            <b-dropdown-item v-if="row.pending_validation_quantity && project.can_certificate" aria-role="listitem" @click="onClickValidate(row)">
                              <span class="text-xs">{{ $t('validate_progress') }}</span>
                            </b-dropdown-item>
                            <b-dropdown-item v-if="project.has_quality_validation && row.pending_quality_validation_quantity && project.can_validate_quality" aria-role="listitem" @click="onClickValidateQuality(row)">
                              <span class="text-xs">{{ $t('validate_quality') }}</span>
                            </b-dropdown-item>
                            <b-dropdown-item separator v-if="!row.completed && row.children_count === 0"></b-dropdown-item>
                            <b-dropdown-item aria-role="listitem" @click="onCompleteChanged(row)" v-if="row.children_count == 0" :class="user.collaborator == 1 ? 'cursor-not-allowed':''">
                              <span v-if="!row.completed" class="text-xs font-medium" :class="user.collaborator == 1 ? 'text-gray-400':'text-green'">{{ $t('complete_resource') }}</span>
                              <span v-else class="text-xs font-medium text-red">{{ $t('uncomplete') }}</span>
                            </b-dropdown-item>
                          </b-dropdown>
                        </div>
                      </td>

                    </tr>

                    <!-- Recorremos los sub recursos -->
                    <tr v-if="row.children_count > 0" :key="'sub_'+row.id">

                      <td colspan="5" :class="{'hidden': !(row.id == selected)}" >

                        <!-- loading -->
                        <div v-if="row.children.length == 0" class="flex justify-center items-center">

                          <scale-loader />
                        </div>

                        <table v-else
                        class="w-full">

                          <!-- Cabecera Separadora -->
                          <tr class="bg-indigo-lightest">
                            <td colspan="5" class="p-4">
                              <div class="flex justify-start w-auto h-full align-middle">
                                <b-icon icon="list" pack="fas" size="is-small" class="ml-1 text-blue"></b-icon>
                                <span class="ml-2 text-xs font-semibold uppercase text-blue">{{ getRealChildren(row.children)}} {{ $t("resources") }}</span>
                              </div>
                            </td>
                          </tr>

                          <!-- Cabeceras de tabla -->
                          <tr class="bg-blue-lightest">
                            <th class="p-2 text-sm font-semibold text-center uppercase text-blue-dark"></th>
                            <th class="p-2 text-sm font-semibold uppercase text-blue-dark">{{ $t("resource") }}</th>
                            <th class="p-2 text-sm font-semibold uppercase text-blue-dark">{{ $t("interval") }}</th>
                            <th class="p-2 text-sm font-semibold uppercase text-blue-dark">{{ $t("progress_label") }}</th>
                            <th class="p-2 text-sm font-semibold uppercase text-blue-dark"></th>
                          </tr>

                          <!-- Subrecursos -->
                          <tbody>

                            <template v-for="rowSub in row.children">

                              <tr class=" bg-grey-lighter hover:bg-grey-light" v-if="!rowSub.is_header_row" :key="rowSub.id">

                                <!-- Icono Historial -->
                                <td class="justify-start w-auto h-full p-4 align-middle">
                                  <div v-if="rowSub.lines" class="flex text-center align-middle cursor-pointer" @click="displaySubHistory(rowSub.id)">
                                    <span class="mr-1 text-xs font-semibold text-blue">{{ rowSub.lines.length }}</span>
                                    <b-icon icon="history" pack="fas" size="is-small" class="mr-1 text-blue"></b-icon>
                                    <b-icon :icon=" (rowSub.id == selectedSubHistory) ? 'chevron-up' : 'chevron-down'" pack="fas" size="is-small" class="text-blue"></b-icon>
                                  </div>
                                </td>

                                <!-- Titulo / Peso -->
                                <td class="p-2" v-if="!rowSub.completed">
                                  <div class="text-xs font-semibold">{{ rowSub.name }}</div>
                                  <div class="text-xs text-blue"><span class="font-semibold">{{ $t('resource_weight_msg', [formatWeight(rowSub.weight)]) }}</span></div>
                                </td>
                                <td class="p-2" v-else>
                                  <div class="flex flex-row items-center">
                                    <div class="w-2 h-2 mr-1 rounded-full bg-green"></div>
                                    <div class="text-xs font-semibold">{{ rowSub.name }}</div>
                                  </div>
                                  <div class="text-xs text-blue"><span class="font-semibold">{{ $t('resource_weight_msg', [formatWeight(rowSub.weight)]) }}</span></div>
                                </td>

                                <!-- Fechas / Plazo-->
                                <td class="p-2">
                                  <div class="flex flex-col" v-if="rowSub.start_date != null">
                                    <div class="text-xs">{{ $t('resource_date_interval', [moment(rowSub.start_date).format('DD/MM/YYYY'), moment(rowSub.end_date).format('DD/MM/YYYY')]) }}</div>
                                    <div class="flex flex-row items-center" v-if="rowSub.end_date > realEndDate">
                                      <div class="w-2 h-2 rounded-full bg-red"></div>
                                      <div class="ml-1 text-xs font-medium text-red">{{ $t('activity_time_status_danger') }}</div><!-- fuera de plazo -->
                                    </div>
                                    <div class="flex flex-row items-center" v-else>
                                      <div class="w-2 h-2 rounded-full bg-green"></div>
                                      <div class="ml-1 text-xs font-medium text-green">{{ $t('activity_time_status_ok') }}</div><!-- en plazo -->
                                    </div>
                                  </div>
                                  <div class="flex flex-col" v-else>
                                    <div class="text-xs" >{{ $t('not_started') }}</div><!-- sin iniciar -->
                                    <div class="flex flex-row items-center">
                                      <div class="w-2 h-2 rounded-full bg-grey"></div>
                                      <div class="ml-1 text-xs font-medium text-grey">{{ $t('pending_execution') }}</div><!-- pendiente de ejecutar -->
                                    </div>
                                  </div>
                                </td>

                                <!-- Pendiente / Ejecutado -->
                                <td class="p-2">
                                  <div class="flex flex-col">
                                    <div class="text-xs text-grey-dark">
                                      {{ formatPendingDisplay(rowSub) }}
                                      {{ rowSub.unit.code }} {{ $t('pendings') }}
                                    </div>
                                    <div class="text-xs font-medium text-blue">
                                      {{ formatExecutedDisplay(rowSub) }} /
                                      {{ formatTotalDisplay(rowSub) }} {{ rowSub.unit.code }} {{ $t('executed') }}
                                    </div>
                                    <div class="text-xs font-medium text-orange" v-if="rowSub.pending_validation_quantity">{{ formatAssignmentQuantity(rowSub.pending_validation_quantity, rowSub) }} {{ rowSub.unit.code }} {{ $t('pending_validation_quantity').toLowerCase() }}</div>
                                  </div>
                                </td>

                                <!-- Opciones -->
                                <td class="justify-center w-auto h-full p-4 align-middle">
                                  <div class="text-center cursor-pointer">
                                    <b-dropdown aria-role="list" position="is-bottom-left">
                                      <template #trigger="{ active }">
                                          <b-icon :icon="active ? 'ellipsis-h' : 'ellipsis-v'" pack="fas" size="is-small" class="text-blue"></b-icon>
                                      </template>
                                      <b-dropdown-item aria-role="listitem" @click="onNameClick(rowSub, true)" v-if="!rowSub.completed && canRecordActualprogress" >
                                        <span class="text-xs">{{ $t('actual_progress') }}</span>
                                      </b-dropdown-item>
                                      <b-dropdown-item aria-role="listitem" @click="onNameClick(rowSub)" v-if="!rowSub.completed">
                                        <span class="text-xs">{{ registerProgressLabel(rowSub) }}</span>
                                      </b-dropdown-item>
                                      <b-dropdown-item aria-role="listitem" @click="onClickEdit(rowSub)" v-if="!rowSub.completed" :disabled="!canEditAssignments()">
                                        <span class="text-xs">{{ $t('edit') }}</span>
                                      </b-dropdown-item>
                                      <b-dropdown-item v-if="rowSub.pending_validation_quantity && project.can_certificate"
                                       aria-role="listitem" @click="onClickValidate(rowSub)">
                                        <span class="text-xs">{{ $t('validate_progress') }}</span>
                                      </b-dropdown-item>
                                      <b-dropdown-item v-if="project.has_quality_validation && rowSub.pending_quality_validation_quantity && project.can_validate_quality"
                                       aria-role="listitem" @click="onClickValidateQuality(rowSub)">
                                        <span class="text-xs">{{ $t('validate_quality') }}</span>
                                      </b-dropdown-item>
                                      <b-dropdown-item separator v-if="!rowSub.completed"></b-dropdown-item>
                                      <b-dropdown-item aria-role="listitem" @click="onCompleteChanged(rowSub)" :class="user.collaborator == 1 ? 'cursor-not-allowed':''">
                                          <span v-if="!rowSub.completed" class="text-xs font-medium" :class="user.collaborator == 1 ? 'text-gray-400':'text-green'">{{ $t('complete_resource') }}</span>
                                          <span v-else class="text-xs font-medium text-red">{{ $t('uncomplete') }}</span>
                                      </b-dropdown-item>
                                    </b-dropdown>
                                  </div>
                                </td>

                              </tr>

                              <tr :key="'subhistory_'+rowSub.id">
                                <td colspan="5" :class="{'hidden': !(rowSub.id == selectedSubHistory)}" >
                                  <table class="w-full">

                                      <tr class="bg-indigo-lightest">

                                      <td colspan="5" class="p-4">
                                          <div class="flex justify-start w-auto h-full align-middle">
                                          <b-icon icon="history" pack="fas" size="is-small" class="ml-1 text-blue"></b-icon>
                                          <span class="ml-2 text-xs font-semibold text-blue">{{ $t('resource_history_header') }}</span>
                                          </div>
                                      </td>
                                      </tr>

                                      <tr class="bg-blue-lightest">
                                          <th align="center" class="p-2 text-sm font-semibold uppercase text-blue-dark">{{ $t('date') }}</th>
                                          <th class="p-2 text-sm font-semibold uppercase text-blue-dark">{{ $t('user') }}</th>
                                          <th align="center" class="p-2 text-sm font-semibold uppercase text-blue-dark">{{ $t('action') }}</th>
                                          <th class="p-2 text-sm font-semibold uppercase text-blue-dark">{{ $t('observations') }}</th>
                                          <th>&nbsp;</th>
                                      </tr>

                                      <tbody>
                                          <template v-for="rowSubHistory in rowSub.lines">
                                          <tr :key="rowSubHistory.id" class="hover:bg-grey-lightest">

                                              <td align="center" class="justify-start w-auto h-full p-4">
                                                  <div class="text-xs text-center">
                                                  <!--
                                                    <l-timeago
                                                      :since="rowSubHistory.created_at"
                                                      :locale="locale"
                                                      class="my-1 text-xs font-semibold text-blue-light"
                                                  />
                                                  -->
                                                    <div class="my-1 text-xs font-semibold text-blue-light">
                                                      {{dateToText(rowSubHistory.created_at)}}
                                                    </div>
                                                  </div>
                                              </td>

                                              <td class="p-2">

                                                  <div class="flex flex-row items-center justify-start w-auto h-full">
                                                  <div class="w-8 h-8 rounded-full">
                                                      <img class="w-8 h-8 rounded-full" :src="rowSubHistory.user.avatar"/>
                                                  </div>
                                                  <div class="flex flex-col ml-2">
                                                      <div class="text-xs">{{ rowSubHistory.user.fullname}}</div>
                                                      <div class="text-xs text-grey-dark">{{ rowSubHistory.user.area}}</div>
                                                  </div>
                                                  </div>

                                              </td>

                                              <td align="center" class="h-full p-4">
                                                  <div class="text-xs">
                                                    <span v-if="rowSubHistory.completed == 1 && rowSubHistory.executed_quantity == 0">
                                                      {{ $t('completed_the_resource') }}
                                                    </span>
                                                    <span v-else>
                                                      <span v-if="rowSubHistory.status == 0">{{ $t('execute') }}</span>
                                                      <span v-if="rowSubHistory.status == 1">{{ $t('pending_confirmation') }}</span>
                                                      <span v-if="rowSubHistory.status == 2">{{ $t('execution_rejected') }}</span>
                                                      <span v-if="rowSubHistory.status == 3">{{ $t('validated_action') }}</span>
                                                      <span v-if="rowSubHistory.status == 4">{{ $t('rejected_action') }}</span>
                                                      <span v-if="rowSubHistory.status == 6 || rowSubHistory.status == 8">{{ $t('quality_validated_action') }}</span>
                                                      <span v-if="rowSubHistory.status == 7">{{ $t('quality_rejected_action') }}</span>
                                                      <span v-if="rowSubHistory.status == 10">{{ $t('actual_progress') }}</span>
                                                      {{ rowSubHistory.executed_quantity}} {{ rowSubHistory.unit.name}}
                                                    </span>
                                                  </div>
                                              </td>

                                              <td class="w-2/5 p-2">
                                                  <div class="flex flex-col">
                                                  <div class="text-xs" v-html="rowSubHistory.observation"></div>
                                                  <div class="flex flex-row flex-wrap">
                                                    <template v-for="rowDocument in rowSubHistory.documents">
                                                      <b-tooltip :label="rowDocument.name" position="is-top" :key="rowDocument.document_id">
                                                        <div @click="showPreview(rowDocument)" :key="rowDocument.document_id" class="w-12 h-12 m-1 rounded-lg shadow cursor-pointer bg-grey">
                                                          <img class="w-12 h-12 rounded-lg" :src="rowDocument.file.raw" onerror="this.src='https://epc-tracker-assets.s3.eu-west-3.amazonaws.com/public/document.jpeg'" />
                                                        </div>
                                                      </b-tooltip>
                                                    </template>
                                                  </div>
                                                  </div>
                                              </td>

                                              <td class="justify-center w-auto h-full p-1 align-middle">
                                                <div v-if="canManage && [0, 10].includes(rowSubHistory.status)" @click="annulAction(rowSubHistory, rowSub.id)">
                                                  <b-tooltip :label="$t('annul_action')" position="is-left" :key="'sub_annul_'+rowSubHistory.id">
                                                    <b-icon icon="trash-alt" pack="fas" size="is-small" class="ml-1 text-blue" ></b-icon>
                                                  </b-tooltip>
                                                </div>
                                                <!-- edit line -->
                                                <div v-if="(project.can_admin || project.can_certificate) && (rowSubHistory.status == 0 || rowSubHistory.status == 10)"
                                                  @click="onEditLine(rowSubHistory, rowSub)"
                                                  class="cursor-pointer"
                                                >
                                                  <b-tooltip :label="$t('edit_line')" position="is-left" :key="'edit_line_'+rowSubHistory.id">
                                                    <b-icon icon="edit" pack="fas" size="is-small" class="ml-1 text-blue"></b-icon>
                                                  </b-tooltip>
                                                </div>
                                              </td>

                                          </tr>
                                          </template>
                                      </tbody>

                                  </table>
                              </td>
                            </tr>

                            </template>

                          </tbody>

                        </table>

                      </td>

                    </tr>

                    <tr v-else  :key="'resource_history_'+row.id">
                      <td colspan="5" :class="{'hidden': !(row.id == selectedHistory)}" >
                          <table class="w-full">

                              <tr class="bg-indigo-lightest">
                                  <td colspan="5" class="p-4">
                                      <div class="flex justify-start w-auto h-full align-middle">
                                      <b-icon icon="history" pack="fas" size="is-small" class="ml-1 text-blue"></b-icon>
                                      <span class="ml-2 text-xs font-semibold text-blue">{{ $t('resource_history_header') }}</span>
                                      </div>
                                  </td>
                              </tr>

                              <tr class="bg-blue-lightest">
                                  <th align="center" class="p-2 text-sm font-semibold uppercase text-blue-dark">{{ $t('date') }}</th>
                                  <th class="p-2 text-sm font-semibold uppercase text-blue-dark">{{ $t('user') }}</th>
                                  <th align="center" class="p-2 text-sm font-semibold uppercase text-blue-dark">{{ $t('action') }}</th>
                                  <th class="p-2 text-sm font-semibold uppercase text-blue-dark">{{ $t('observations') }}</th>
                                  <th>&nbsp;</th>
                              </tr>

                              <tbody>
                                  <template v-for="rowHistory in row.lines">
                                  <tr :key="'history_line_'+rowHistory.id" class="hover:bg-grey-lightest">

                                      <td align="center" class="justify-start w-auto h-full p-4">
                                          <div class="text-xs text-center">
                                          <!-- <l-timeago
                                              :since="rowHistory.created_at"
                                              :locale="locale"
                                              class="my-1 text-xs font-semibold text-blue-light"
                                          />
                                          -->
                                            <div class="my-1 text-xs font-semibold text-blue-light">
                                              {{dateToText(rowHistory.created_at)}}
                                            </div>
                                          </div>
                                      </td>

                                      <td class="p-2">

                                          <div class="flex flex-row items-center justify-start w-auto h-full">
                                          <div class="w-8 h-8 rounded-full">
                                              <img class="w-8 h-8 rounded-full" :src="rowHistory.user.avatar"/>
                                          </div>
                                          <div class="flex flex-col ml-2">
                                              <div class="text-xs">{{ rowHistory.user.fullname}}</div>
                                              <div class="text-xs text-grey-dark">{{ rowHistory.user.area}}</div>
                                          </div>
                                          </div>

                                      </td>

                                      <td align="center" class="h-full p-4">
                                              <div class="text-xs">
                                                <span v-if="rowHistory.completed == 1 && rowHistory.executed_quantity == 0">
                                                  {{ $t('completed_the_resource') }}
                                                </span>
                                                <span v-else>
                                                  <span v-if="rowHistory.status == 0">{{ canRecordActualprogress ? $t('inspected_progress') : $t('execute') }}</span>
                                                  <span v-if="rowHistory.status == 1">{{ $t('pending_confirmation') }}</span>
                                                  <span v-if="rowHistory.status == 2">{{ $t('execution_rejected') }}</span>
                                                  <span v-if="rowHistory.status == 3 || rowHistory.status == 5">{{ $t('validated_action') }}</span>
                                                  <span v-if="rowHistory.status == 4">{{ $t('rejected_action') }}</span>
                                                  <span v-if="rowHistory.status == 6 || rowHistory.status == 8">{{ $t('quality_validated_action') }}</span>
                                                  <span v-if="rowHistory.status == 7">{{ $t('quality_rejected_action') }}</span>
                                                  <span v-if="rowHistory.status == 10">{{ $t('actual_progress') }}</span>
                                                  {{ rowHistory.executed_quantity}} {{ rowHistory.unit.name}}

                                                  <!-- Información extra de cuanto se rechazo en validacion parcial -->
                                                  <span v-if="(rowHistory.status == 5 || rowHistory.status == 8 || rowHistory.status == 0) && rowHistory.executed_quantity != rowHistory.total_quantity">
                                                    <br>
                                                    y rechazó {{ (rowHistory.total_quantity - rowHistory.executed_quantity).toFixed(2)}} {{ rowHistory.unit.name}}
                                                  </span>

                                                  <br> <span>{{ $t('resource_date_interval', [moment(rowHistory.start_date).format('DD/MM/YYYY'), moment(rowHistory.end_date).format('DD/MM/YYYY')]) }}
                                                  </span>
                                                </span>
                                              </div>
                                      </td>

                                      <td class="w-2/5 p-2">
                                          <div class="flex flex-col">
                                          <div class="text-xs" v-html="rowHistory.observation"></div>
                                          <div class="flex flex-row flex-wrap">

                                            <template v-for="rowDocument in rowHistory.documents">
                                            <b-tooltip :label="rowDocument.name" position="is-top" :key="rowDocument.document_id">
                                              <div @click="showPreview(rowDocument)" class="w-12 h-12 m-1 rounded-lg shadow cursor-pointer bg-grey">
                                                <img class="w-12 h-12 rounded-lg" :src="rowDocument.file.thumbnail" onerror="this.src='https://epc-tracker-assets.s3.eu-west-3.amazonaws.com/public/document.jpeg'" />
                                              </div>
                                            </b-tooltip>
                                            </template>

                                          </div>
                                          </div>
                                      </td>

                                      <td class="justify-center w-auto h-full p-1 align-middle">
                                        <div v-if="canManage && [0, 10].includes(rowHistory.status)" @click="annulAction(rowHistory, row.id)">
                                          <b-tooltip :label="$t('annul_action')" position="is-left" :key="'annul_'+rowHistory.id">
                                            <b-icon icon="trash-alt" pack="fas" size="is-small" class="ml-1 text-blue" ></b-icon>
                                          </b-tooltip>
                                        </div>
                                        <div v-if="(project.can_admin || project.can_certificate) && (rowHistory.status == 0 || rowHistory.status == 10)"
                                          @click="onEditLine(rowHistory, row)"
                                          class="cursor-pointer"
                                        >
                                          <b-tooltip :label="$t('edit')" position="is-left" :key="'edit_line_'+rowHistory.id">
                                            <b-icon icon="edit" pack="fas" size="is-small" class="ml-1 text-blue"></b-icon>
                                          </b-tooltip>
                                        </div>
                                      </td>

                                  </tr>
                                  </template>
                              </tbody>

                          </table>
                      </td>
                    </tr>

                  </template>
                </tbody>
              </table>
            </div>

          </b-tab-item>

          <!-- task 2 reestructurado -->
          <b-tab-item v-if="pictogramId == null">
            <template #header>
              <span> {{ $t('tasks') }}
                <b-icon v-show="isLoadingTask"
                  pack="fas"
                  icon="spinner"
                  class="fa-pulse"
                  size="is-small">
                </b-icon>
                <b-tag v-show="!isLoadingTask" rounded class="font-semibold"> {{ listTasks.length }} </b-tag>
              </span>
            </template>

            <div class="w-full">
              <assignment-task
               ref="assignmentTask"
               :listTasks="listTasks"
               :can-add="canAdd"
               :canManage="canManage"
               :entityId="parseInt(entityId)"
               :entityType="entityType"
               :subactivityId="subactivityId"
               :activityName="activityName"
               :taskStatus="taskStatus"
               :parentTaskStatus="parentTaskStatus"
               @reload="() => reload()"
               @update:listTasks="listTasks = $event"
              >
              </assignment-task>
            </div>

          </b-tab-item>

          <!-- Certifiers -->
          <b-tab-item v-if="pictogramId == null">
            <template #header>
              <span> {{ $t('certifiers') }}
                <b-icon v-show="isLoadingCertifier"
                  pack="fas"
                  icon="spinner"
                  class="fa-pulse"
                  size="is-small">
                </b-icon>
                <b-tag v-show="!isLoadingCertifier" rounded class="font-semibold"> {{ listCertifiers.length }} </b-tag>
              </span>
            </template>

            <div class="w-full">
              <div class="flex flex-row justify-between text-sm uppercase align-middle text-blue-light">
                <div>
                  <b-button
                    @click="() => { assignmentType = 'certifiers'; $refs.assignment_certified_execution_modal.show() }"
                    @reload="() => reload()"
                    v-if="canManageCertifiers"
                    type="is-small is-primary"
                    class="font-semibold uppercase">{{ $t("upload_certification") }}
                  </b-button>
                </div>

                <div>
                  <b-button
                    @click="onClickUnlockMeasurementsButton"
                    @reload="() => reload()"
                    v-if="canManageCertifiers"
                    type="is-small is-primary"
                    class="font-semibold uppercase">
                      <span v-if="assignmentsLocked">{{ $t("unlock_measurements") }}</span>
                      <span v-else>{{ $t("lock_measurements") }}</span>
                  </b-button>
                </div>

                <b-field>
                  <b-tag v-if="assignmentsLocked" type="is-success">
                      <span>{{ $t('blocked') }}</span>
                  </b-tag>
                  <b-tag v-else type="is-warning">
                      <span>{{ $t('unlocked') }}</span>
                  </b-tag>
                </b-field>
              </div>

              <div v-if="isLoadingCertifier" class="my-4 text-center">
                <scale-loader />
              </div>

              <div v-else class="flex flex-row justify-between mt-3 text-sm uppercase align-middle text-blue-light">

                <div>
                  <span v-if="listCertifiers.length" class="font-semibold">{{ listCertifiers.length }}</span> {{ !listCertifiers.length ? $t("no_certifiers_found") : $t("certifiers_under_execution") }}
                </div>

              </div> <!-- creo que sobra -->

              <!-- Tabla de Certificadoras -->
              <div class="flex items-center my-4" v-if="!isLoadingCertifier && listCertifiers.length">

                  <table class="w-full">

                    <thead class="bg-blue-lightest">
                      <tr>
                        <th class="p-2 text-sm font-semibold text-center uppercase text-blue-dark"></th>
                        <th class="p-2 text-sm font-semibold uppercase text-blue-dark">{{ $t("name") }}</th>
                        <th class="p-2 text-sm font-semibold uppercase text-blue-dark">{{ $t("progress") }}</th>
                      </tr>
                    </thead>

                    <tbody>
                      <template v-for="row in listCertifiers">

                        <!-- Recorremos las certificadoras -->
                        <tr class="hover:bg-grey-lightest" :key="row.id">

                          <!-- Icono Detalles / Historia -->
                          <td class="justify-start w-auto h-full p-4 align-middle">

                            <div class="flex text-center align-middle cursor-pointer" @click="displayHistory(row.id)">
                              <b-tooltip
                                :label="$t('display_history',[(row.lines ? row.lines.length : 0)])"
                                position="is-right"
                              >
                                <span class="mr-1 text-xs font-semibold text-blue">{{ row.lines ? row.lines.length : 0 }}</span>
                                <b-icon icon="history" pack="fas" size="is-small" class="mr-1 text-blue"></b-icon>
                                <b-icon :icon=" (row.id == selectedHistory) ? 'chevron-up' : 'chevron-down'" pack="fas" size="is-small" class="text-blue"></b-icon>
                              </b-tooltip>
                            </div>
                          </td>

                          <!-- Nombre -->
                          <td class="p-2" v-if="!row.completed">
                            <div class="text-xs font-semibold">{{ row.name }}</div>
                          </td>
                          <td class="p-2" v-else>
                            <div class="flex flex-row items-center">
                              <div class="w-2 h-2 mr-1 rounded-full bg-green"></div>
                              <div class="text-xs font-semibold">{{ row.name }}</div>
                            </div>
                          </td>
                          <!-- Total unit -->
                          <!-- <td class="p-2">
                            <div class="flex flex-col">
                              <div class="text-xs">{{ row.total_units }} / {{ row.unit.code }}</div>
                            </div>
                          </td> -->
                          <!-- Pendiente / Ejecutado -->
                          <td class="p-2">
                            <div class="flex flex-col">
                              <div class="text-xs">{{ row.total_units }} {{ row.unit.code }} {{ $t("total").toLowerCase() }}</div>
                              <div class="text-xs text-grey-dark">{{ calculateCertifierValues(row, 'pending') }} {{ row.unit.code }} {{ $t('pendings') }}</div>
                              <div class="text-xs font-medium text-blue">{{ calculateCertifierValues(row, 'assigned') }} {{ row.unit.code }} {{ $t('certified').toLowerCase() }}</div>
                            </div>
                          </td>
                        </tr>

                        <tr  :key="'certifier_history_'+row.id">
                          <td colspan="5" :class="{'hidden': !(row.id == selectedHistory)}" >
                              <table class="w-full">

                                  <tr class="bg-indigo-lightest">

                                      <td colspan="4" class="p-4">
                                              <div class="flex justify-start w-auto h-full align-middle">
                                              <b-icon icon="history" pack="fas" size="is-small" class="ml-1 text-blue"></b-icon>
                                              <span class="ml-2 text-xs font-semibold text-blue">{{ $t('resource_history_header') }}</span>
                                              </div>
                                          </td>
                                          </tr>

                                          <tr class="bg-blue-lightest">
                                              <th align="center" class="p-2 text-sm font-semibold uppercase text-blue-dark">{{ $t('date') }}</th>
                                              <th class="p-2 text-sm font-semibold uppercase text-blue-dark">{{ $t('user') }}</th>
                                              <th align="center" class="p-2 text-sm font-semibold uppercase text-blue-dark">{{ $t('action') }}</th>
                                              <th class="p-2 text-sm font-semibold uppercase text-blue-dark">{{ $t('observations') }}</th>
                                          </tr>

                                  <tbody>
                                      <template v-for="rowHistory in row.lines">
                                      <tr :key="rowHistory.id" class="hover:bg-grey-lightest">

                                          <td align="center" class="justify-start w-auto h-full p-4">
                                              <div class="text-xs text-center">
                                                <!--
                                                <l-timeago
                                                    :since="rowHistory.created_at"
                                                    :locale="locale"
                                                    class="my-1 text-xs font-semibold text-blue-light"
                                                />
                                                -->
                                                <div class="my-1 text-xs font-semibold text-blue-light">
                                                  {{dateToText(rowHistory.created_at)}}
                                                </div>
                                              </div>
                                          </td>

                                          <td class="p-2">

                                              <div class="flex flex-row items-center justify-start w-auto h-full">
                                              <div class="w-8 h-8 rounded-full">
                                                  <img class="w-8 h-8 rounded-full" :src="rowHistory.user.avatar"/>
                                              </div>
                                              <div class="flex flex-col ml-2">
                                                  <div class="text-xs">{{ rowHistory.user.fullname}}</div>
                                                  <div class="text-xs text-grey-dark">{{ rowHistory.user.area}}</div>
                                              </div>
                                              </div>

                                          </td>

                                          <td align="center" class="h-full p-4">
                                                  <div class="text-xs">{{ $t('execute') }} {{ rowHistory.executed_quantity}} {{ rowHistory.unit.name }}</div>
                                          </td>

                                          <td class="w-2/5 p-2">
                                              <div class="flex flex-col">
                                              <div class="text-xs" v-html="rowHistory.observation"></div>
                                              <div class="flex flex-row flex-wrap">

                                                <template v-for="rowDocument in rowHistory.documents">
                                                  <b-tooltip :label="rowDocument.name" position="is-top" :key="rowDocument.document_id">
                                                    <div @click="showPreview(rowDocument)" class="w-12 h-12 m-1 rounded-lg shadow cursor-pointer bg-grey">
                                                      <img class="w-12 h-12 rounded-lg" :src="rowDocument.file.thumbnail" onerror="this.src='https://epc-tracker-assets.s3.eu-west-3.amazonaws.com/public/document.jpeg'" />
                                                    </div>
                                                  </b-tooltip>
                                                </template>
                                              </div>
                                              </div>
                                          </td>

                                      </tr>
                                      </template>
                                  </tbody>

                              </table>
                          </td>
                        </tr>

                      </template>
                    </tbody>

                </table>

              </div> <!-- table certifiers -->

            </div> <!-- w-full -->

          </b-tab-item>

          <!-- Chapters -->
          <b-tab-item v-if="pictogramId == null">
            <template #header>
              <span> {{ $t('certifiers') + ' ' + $t('chapters') }}
                <b-icon v-show="isLoadingCertifierHead"
                  pack="fas"
                  icon="spinner"
                  class="fa-pulse"
                  size="is-small">
                </b-icon>
                <b-tag v-show="!isLoadingCertifierHead" rounded class="font-semibold"> {{ chaptersCount }} </b-tag>
              </span>
            </template>

            <div class="w-full">
              <!-- tabla de capitulos -->
              <chapter-table-activity
                :listChapters="listChapters"
                :chaptersCount="chaptersCount"
                :canManageCertifiers="canManageCertifiers"
                :assignmentsLocked="!assignmentsLocked || (assignmentsLocked && canManageCertifiers)"
                @show-execution-modal="() => {  assignmentType = 'chapters'; $refs.assignment_certified_execution_modal.show() }"
                @unlock-measurements="onClickUnlockMeasurementsButton"
                :is-loading="isLoadingCertifierHead"
              />
            </div>
          </b-tab-item>

          <!-- Pictograms -->
          <b-tab-item v-if="pictogramId != null">
            <template #header>
              <span> {{ $t('pictograms') }}
                <b-icon v-show="isLoadingPictogram"
                  pack="fas"
                  icon="spinner"
                  class="fa-pulse"
                  size="is-small">
                </b-icon>
                <b-tag v-show="!isLoadingPictogram" rounded class="font-semibold"> {{ pictogram ? 1 : 0 }} </b-tag>
              </span>
            </template>

            <div class="w-full">
              <!-- tabla de pictogramas -->
              <pictogram-table-activity
                :pictogram="pictogram"
                :canManageCertifiers="canManageCertifiers"
                :assignmentsLocked="!assignmentsLocked || (assignmentsLocked && canManageCertifiers)"
                :is-loading="isLoadingPictogram"
                :activityId="activityId"
                :subactivityId="subactivityId"
                @show-execution-modal="() => {  assignmentType = 'chapters'; $refs.assignment_certified_execution_modal.show() }"
                @unlock-measurements="onClickUnlockMeasurementsButton"
                @epc-reload="() => reload()"
              />
            </div>
          </b-tab-item>

          <!-- KPIs -->
          <b-tab-item v-if="pictogramId == null && isProjectAdmin">
            <template #header>
              <span>{{ $t('kpis') }}</span>
            </template>
            <activity-kpi :activity-id="activityId" :projectId="resolvedProjectId" @ActivityHomeShowFullWidth="onShowFullWidth"/>
          </b-tab-item>

        </b-tabs>
      </div>
    <!-- </div> -->
    <!-- Modal para crear tarea -->
    <task-modal
      ref="task_modal"
      entity-type="activity"
      :entity-id="entityId"
      @reload="() => reload()"
    />

    <!-- Modal para crear recursos -->
    <assignment-modal
      ref="assignment_modal"
      entity-type="activity"
      :entity-id="entityId"
      @reload="() => reload()"
    />

    <!-- Modal para registrar cantidades ejecutadas de mediciones certificadoras -->
    <assignment-certified-execution-modal
      ref="assignment_certified_execution_modal"
      entity-type="activity"
      :entity-id="entityId"
      :entity-planning-code="activityPlanningCode"
      :assignmentType="assignmentType"
      @reload="() => reload()"
    />

    <!-- Modal para Editar tarea -->
    <task-update-modal
      ref="task_update_modal"
      entity-type="activity"
      :entity-id="entityId"
      :canManage="canManage"
      @reload="() => reload()"
    />

    <!-- modal para comentario a tarea  -->
    <assignment-comment-task-modal
      ref="assignment_comment_task_modal"
      entity-type="activity"
      :entity-id="entityId"
      @reload="() => reload()"
      v-if="project.can_admin"
    />

    <!-- Modal para Editar -->
    <assignment-update-modal
      ref="assignment_update_modal"
      entity-type="activity"
      :entity-id="entityId"
      :canManage="canManage"
      @reload="() => reload()"
    />

    <!-- Modal para añadir unidades -->
    <!-- <assignment-contribute-modal
      ref="assignment_contribute_modal"
      entity-type="activity"
      :entity-id="entityId"
      :current-start-date="currentStartDate"
      :current-end-date="currentEndDate"
      @reload="() => reload()"
    /> -->

    <assignment-contribute-drawing-modal
      ref="assignment_contribute_drawing_modal"
      entity-type="activity"
      :entity-id="entityId"
      :current-start-date="currentStartDate"
      :current-end-date="currentEndDate"
      @reload="() => reload()"
    />

    <!-- Modal para completar -->
    <assignment-completed-modal
      ref="assignment_completed_modal"
      entity-type="activity"
      :entity-id="entityId"
      @reload="() => reload()"
    />

    <!-- Modal de registro de tareas -->
    <assignment-register-task-modal
      ref="assignment_register_task_modal"
      entity-type="activity"
      :entity-id="entityId"
      @reload="() => reload()"
    />

    <!-- Modal para editar lineas-->
    <assignment-line-edit-modal
      ref="assignment_line_edit_modal"
      entity-type="activity"
      :entity-id="entityId"
      @reload="() => reload()"
    />

    <!-- Modal para PREVIEW -->
    <assignment-document-preview
        :entity-id="entityId"
        entity-type="activity"
        ref="previewModal"
        :can-delete="canManage"
        @reload="() => reload()"
    />

    <assignment-validate-quantity-modal
        ref="assignment_validate_quantity_modal"
        entity-type="activity"
        :entity-id="entityId"
        @reload="() => {getList('resource', true); getList('task', true);}"
      />

  </div>
</template>

<script>
import axios from "axios";
import entityNotifications from "·/components/entity-notifications";
import assignmentModal from "·/components/assignment-modal";
import taskModal from "·/components/task-modal";
import assignmentUpdateModal from "·/components/assignment-update-modal";
import taskUpdateModal from "·/components/task-update-modal";
// assignmentContributeModal de momento queda comentado, es reemplazado por assignmentContributeDrawingModal
// import assignmentContributeModal from "·/components/assignment-contribute-modal";
import assignmentCompletedModal from "·/components/assignment-completed-modal";
import assignmentRegisterTaskModal from "·/components/assignment-register-task-modal";
import assignmentDocumentPreview from "./assignment-document-preview";
import assignmentCertifiedExecutionModal from "./assignment-certified-execution-modal";
import EventBus from "~/plugins/bus";
import ScaleLoader from "vue-spinner/src/ScaleLoader.vue";
import { mapGetters } from "vuex";
import { formatProjectFigure, quantityDisplayDecimals } from "·/helpers/quantity-display";
import ChapterTableActivity from "../components/chapters/chapter-table-activity.vue";
import PictogramTableActivity from "../components/pictograms/pictogram-table-activity.vue";
import assignmentContributeDrawingModal from "../components/assignments/assignment-contribute-drawing-modal.vue";
import assignmentCommentTaskModal from "·/components/assignment-comment-task-modal";
import assignmentLineEditModal from "·/components/assignment-line-edit-modal";
import AssignmentValidateQuantityModal from '·/components/assignment-validate-quantity-modal';
import AssignmentTask from "./assignments/assignment-task.vue";
import { format } from 'date-fns'
import moment from "moment";
import ActivityKpi from "./activity-kpi.vue";

const ASSIGNMENT_TASK = 'task';
const ASSIGNMENT_RESOURCE = 'resource';
const ASSIGNMENT_CERTIFIER = 'certifier';
const ASSIGNMENT_CERTIFIER_HEAD = 'certifier-head';
const PICTOGRAM = 'pictogram';

export default {
  name: "activity-assignments",

  components: {
    entityNotifications,
    assignmentModal,
    taskModal,
    taskUpdateModal,
    assignmentUpdateModal,
    assignmentContributeDrawingModal,
    // assignmentContributeModal,
    assignmentCompletedModal,
    ScaleLoader,
    assignmentDocumentPreview,
    assignmentCertifiedExecutionModal,
    ChapterTableActivity,
    PictogramTableActivity,
    assignmentCommentTaskModal,
    assignmentLineEditModal,
    AssignmentValidateQuantityModal,
    assignmentRegisterTaskModal,
    ActivityKpi,
    AssignmentTask,
  },

  props: {
    activityId: { type: Number, required: true },
    activityName: { type: String, required: true },
    activityPlanningCode: { type: String, required: false, default: '' },
    pictogramId: { type: Number, required: false, default: null },
    subactivityId: { type: Number, default: 0 },
    canAdd: { type: Boolean, default: false },
    canManageCertifiers: { type: Boolean, default: false },
    canManage: { type: Boolean, default: false },
    endDate: { type: String },
    currentStartDate: { type: String },
    currentEndDate: { type: String },
    blockedAssignments: { type: Number, required: true },
    canRecordActualprogress: { type: Boolean, default: false },
    taskStatus: { type: Number, default: null },
    parentTaskStatus: {type: Number, default: null},
  },

  data: () => ({

    selected: undefined,
    selectedHistory: undefined,
    selectedSubHistory: undefined,
    list: [],
    listTasks: [],
    listCertifiers: [],
    listChapters: [],
    listResources: [],
    pictogram: null,
    documents: [],
    hasWeightingError: false,
    weighting: 0,
    lines: [],
    entityId: null,
    entityType: "activity",
    editedList: [], // copiamos solo los elementos editados para enviarlos al servidor
    originalListResources: [], // copia de seguridad de la lista de recursos original
    isListOpen: false,
    isLoading: true,
    checkboxIsLoading: false,
    openedAssignmentId: 0,
    documentId: 0,
    realEndDate: null,

    assignmentsLocked: false,
    assignmentType: 'certifiers',

    mainActiveTab: 0,
    lastActiveTab: 0,
    firstLoad: true,
    isLoadingTask: false,
    isLoadingResource: false,
    isLoadingCertifier: false,
    isLoadingCertifierHead: false,
    isLoadingPictogram: false,
    isEditing: false,
    editingLoading: false,
    chaptersCount: 0,

    isTaskEditing: false,
    originalListTasks: [],
    editedTaskList: [],

  }),

  computed: {
    ...mapGetters({
      locale: "lang/locale",
      user: "auth/user",
      company: 'app/company',
      project: 'app/project',
    }),
    resolvedProjectId() {
      return this.project && this.project.id ? parseInt(this.project.id) : null;
    },
    isProjectAdmin() {
      return this.project && this.project.can_admin === true;
    },
    titleLabel() {
      let label = this.$t('measurements_system');
      if (this.company.alias == 'elecnor1') {
        label = this.$t('measurements_system_alt');
      }
      return label;
    },
    resourcesLabel() {
      let label = this.$t('resources');
      if (this.company.alias == 'elecnor1') {
        label = this.$t('resources_alt');
      }
      return label;
    },
  },

  watch: {
    activityId(id) {
      if (id > 0) {
        this.isLoading = true;
        this.getList();
      }
    },

    mainActiveTab(value) {
      switch (value) {
        case 1:
          this.getList(ASSIGNMENT_TASK)
          break;

        case 2:
          this.getList(ASSIGNMENT_CERTIFIER)
          break;

        case 3:
          this.getList(ASSIGNMENT_CERTIFIER_HEAD)
          break;

        case 4:
          this.getPictogram()
          break;

        default: // 0
          this.getList(ASSIGNMENT_RESOURCE)
          break;
      }
    }
  },

  async mounted() {
    this.assignmentsLocked = !!this.blockedAssignments
    this.isLoadingResource = true
    this.isLoadingTask = true
    this.isLoadingCertifier = true
    this.isLoadingCertifierHead = true

    // solo mostramos y cargamos las mediciones de recursos, tareas, certificadoras, chapters solo si no tiene asignado un
    // pictograma
    if(this.pictogramId == null) {
      await this.getList(ASSIGNMENT_RESOURCE, true);
      await this.getList(ASSIGNMENT_TASK, true);
      await this.getList(ASSIGNMENT_CERTIFIER, true);
      await this.getList(ASSIGNMENT_CERTIFIER_HEAD, true);
    } else
      await this.getPictogram();

    let self = this;
    EventBus.$on("refreshAssignmentChangedNotifications", async function (e) {
      if (self.entityId === e.activity_id) {
        // Mismo camino que registro local: silent reload de tareas con niveles abiertos.
        await self.reload();
      }
    });
    EventBus.$on("refreshAssignmentCreatedNotifications", async function (e) {
      if (self.entityId === e.activity_id) {
        await self.reload();
      }
    });
    EventBus.$on("refreshAssignmentDeletedNotifications", async function (e) {
      if (self.entityId === e.activity_id) {
        await self.reload();
      }
    });
  },

  created() {
    this.entityId = this.subactivityId || this.activityId;

    // Date fix
    let date_aux = this.endDate.split("/");
    this.realEndDate = date_aux[2] + '-' +date_aux[1] +'-' +date_aux[0];
  },

  beforeDestroy(){
    EventBus.$off("refreshAssignmentChangedNotifications");
    EventBus.$off("refreshAssignmentCreatedNotifications");
    EventBus.$off("refreshAssignmentDeletedNotifications");
  },

  methods: {
    registerProgressLabel(row=null) {
      if (row && row.children_count > 0) {
        return this.$t('see_subresources');
      }
      let label = this.$t('register_progress');
      if (this.company.alias == 'welink') {
        label = this.$t('progress_to_inspect');
      }
      return label;
    },

    getRealChildren(rows){

      return rows.filter(assignment => assignment.is_header_row == 0).length;

    },

    dateToText(date) {
      let dateObject = new Date(date);
      return format(dateObject, 'dd/MM/yyyy HH:mm')
    },

    showPreview(document) {
      this.document = document;
      this.$refs.previewModal.show(this.document);
      if (this.document.exif) {
        EventBus.$emit("load-locations", this.document.exif);
      }
    },

    async displayDetails(row){
      if (row.children && row.children.length > 0) {
        this.selected = (this.selected == row.id) ? undefined : row.id;
        return;
      }

      try {
        this.selected = (this.selected == row.id) ? undefined : row.id;

        const children = await this.getChildrenAssignments('resource', false, row.id);
        let data = children.data;
        if (data && data.assignments) {
          row.children = data.assignments;
        }
      } catch (error) {
        console.error(error);
      }
    },

    displayHistory(rowId){

      this.selectedHistory = (this.selectedHistory == rowId) ? undefined : rowId;
    },


    displaySubHistory(rowId){

      this.selectedSubHistory = (this.selectedSubHistory == rowId) ? undefined : rowId;
    },

    // async getList() {where_type
    //   let args = {
    //     withLines: 1
    //   };

    //   let url = "/api/v2/assignments/activity/" + this.entityId;
    //   const response = await axios.get(url, { params: args });
    //   let data = response.data;
    //   if (data && data.assignments) {
    //     this.listTasks = data.assignments.filter(assignment => assignment.type == ASSIGNMENT_TASK);
    //     this.listResources = data.assignments.filter(assignment => ((assignment.type == ASSIGNMENT_RESOURCE) && (assignment.is_header_row == 0 )));
    //     this.listCertifiers = data.assignments.filter(assignment => assignment.type == ASSIGNMENT_CERTIFIER );
    //     this.listChapters = data.assignments.filter(assignment => assignment.type == ASSIGNMENT_CERTIFIER_HEAD);
    //     // listChapters tiene el listado de mediciones cabecera, y las que tengan certifiers colgando las tendrán en el atributo 'children'
    //     // Estos children serán añadidos a listChapters para ser dibujados por completo en el arbol. Esto proceso se hace
    //     // en el metodo _listChapters de chapter-table-activity.vue
    //     // Por eso tomamos el numero de capitulos aqui antes de que se inserten en listChapters el resto de mediciones 'certifiers'
    //     this.chaptersCount = this.listChapters.length
    //     this.documents = data.documents || [];
    //     this.hasWeightingError = this.checkWeightingError();
    //     this.isLoading = false;
    //   }
    // },

    async getList(type, force_load = false) {
      if (this.loadAssignments(type, force_load)) {
        let args = {
          withLines: 1,
          where_type: type
        };

        // Solo tareas: refresh silencioso cuando ya hay árbol cargado.
        const silentTaskReload = type === ASSIGNMENT_TASK
          && force_load
          && this.listTasks.length > 0;

        if (!silentTaskReload) {
          this.stateLoading(type, true) // habilitamos el loading que corresponde
        }
        try {
          let url = "/api/v2/assignments/activity/" + this.entityId;
          const response = await axios.get(url, { params: args });

          let data = response.data;
          if (data && data.assignments) {
            if( type === ASSIGNMENT_RESOURCE ) {
              this.listResources = data.assignments;
              if (this.listResources.length > 0 && this.firstLoad) {
                this.mainActiveTab = 0;
                this.firstLoad = false;
              }
            }
            if( type === ASSIGNMENT_TASK ){
              if (silentTaskReload) {
                // nextTick: el ref de la pestaña tareas puede no estar listo en el mismo tick
                // (p.ej. refresco por notificación mientras se monta/actualiza el tab).
                await this.$nextTick();
                if (this.$refs.assignmentTask?.applySilentTaskReload) {
                  await this.$refs.assignmentTask.applySilentTaskReload(data.assignments);
                } else {
                  this.listTasks = data.assignments;
                }
              } else {
                this.listTasks = data.assignments;
              }
              if (this.listTasks.length > 0  && this.firstLoad) {
                this.mainActiveTab = 1;
                this.firstLoad = false;
              }
            }
            if( type === ASSIGNMENT_CERTIFIER ){
              this.listCertifiers = data.assignments;
              if (this.listCertifiers.length > 0 && this.firstLoad) {
                this.mainActiveTab = 2;
                this.firstLoad = false;
              }
            }
            if( type === ASSIGNMENT_CERTIFIER_HEAD ) {
              this.listChapters = data.assignments;
              if (this.listChapters.length > 0 && this.firstLoad) {
                this.mainActiveTab = 3;
                this.firstLoad = false;
              }
            }
            // listChapters tiene el listado de mediciones cabecera, y las que tengan certifiers colgando las tendrán en el atributo 'children'
            // Estos children serán añadidos a listChapters para ser dibujados por completo en el arbol. Esto proceso se hace
            // en el metodo _listChapters de chapter-table-activity.vue
            // Por eso tomamos el numero de capitulos aqui antes de que se inserten en listChapters el resto de mediciones 'certifiers'
            this.chaptersCount = data.chaptersCount || this.listChapters.length
            this.documents = data.documents || [];
            this.hasWeightingError = this.checkWeightingError();
          }
        } finally {
          if (!silentTaskReload) {
            this.stateLoading(type, false) // deshabilitamos el loading que corresponde
          }
        }

      }
    },

    async getChildrenAssignments(type, force_load = false, parent_assignment_id, only_codes = false) {
      let args = {
        parent_assignment_id: parent_assignment_id,
        withLines: 1,
        where_type: type,
        only_children_codes: only_codes ? 1 : null,
      };

      let url = "/api/v2/assignments/activity/" + this.entityId;
      return axios.get(url, { params: args });
    },

    async getPictogram() {

      if (!this.isLoadingPictogram && this.pictogram == null && this.pictogramId != null) {
        this.isLoadingPictogram = true
        let url = "/api/v2/pictogram/" + this.pictogramId;
        const response = await axios.get(url, { params: {} });

        let data = response.data;
        if (data && data.pictogram) {
          this.pictogram = data.pictogram;
        }

      }
      this.isLoadingPictogram = false
    },

    async reload() {
      // TODO: lo que a continuación se hace no es optimo para el nuevo modo de obtener las mediciones
      // en la notificación debería llegar un parametro notificando qué tipo de medición se actualizó
      // ademas mandamos un parametro force_load en true para forzar la carga de todas las mediciones
      // Tareas con datos previos: getList hace refresh silencioso (sin loader) preservando niveles abiertos.
      // Serializamos: registro local + notificación pusher pueden disparar reload a la vez.
      if (this._reloadInFlight) {
        this._reloadQueued = true;
        return;
      }
      this._reloadInFlight = true;
      try {
        do {
          this._reloadQueued = false;
          if (this.pictogramId == null) {
            await Promise.all([
              this.getList(ASSIGNMENT_RESOURCE, true),
              this.getList(ASSIGNMENT_TASK, true),
              this.getList(ASSIGNMENT_CERTIFIER, true),
              this.getList(ASSIGNMENT_CERTIFIER_HEAD, true),
            ]);
          } else {
            this.pictogram = null // seteamos a null para que se recargue el pictograma
            await this.getPictogram();
          }
          this.selected = undefined;
          this.$emit("reload");
        } while (this._reloadQueued);
      } finally {
        this._reloadInFlight = false;
      }
    },

    /**
     * Comprueba si puede abrirse el modal de edición para esa fila
     */
    canOpenEditModal(row) {
      return this.canManage; // || row.user_id === this.user.id. Solo editan managers proyecto
    },

    /**
     * Comprueba si puede añadir o editar mediciones
     */
    canEditAssignments() {
      return !this.assignmentsLocked || (this.assignmentsLocked && this.canManageCertifiers)
    },

    /**
     *
     */
    getClassColorAssignmentLineStatus(status) {
      switch (status) {
        case 0: // inspected progress
          return 'hover:bg-grey-lightest bg-blue-lightest'
        case 10: // actual progress
          return 'hover:bg-grey-lightest bg-green-lightest'
        case 1: // validation pending
          return 'hover:bg-grey-lightest bg-yellow-lightest'
        case 2: // rejected
          return 'hover:bg-grey-lightest bg-red-lightest'
        case 3: // action validation
          return 'hover:bg-grey-lightest bg-blue-lightest'
        case 4: // action validation rejected
          return 'hover:bg-grey-lightest bg-red-lightest'
        default:
          return 'bg-grey-lightest'
      }
    },

    /**
     * Comprueba si la fila es de una tarea
     */
    isTask(row) {
      return row.type === "task";
    },

    /**
     * comprobamos si la medicion tienen lines con status = 1
     * que quiere decir que tiene una linea pendiente de validación
     */
    hasPendingValidation(row) {
      if (!row.lines || !row.lines.length) return false;

      return row.lines.some(line => line.status === 1);
    },

    /**
     * Obtiene el valor utilizado dentro de la pelotita (cantidad ejecutada)
     */
    getDisplayQuantity(row) {
      if (this.isTask(row)) return "✔";

      return this.twoDecimals(this.getExecutedQuantity(row));
    },

    getRemaining(row) {
      if (this.isTask(row)) return "";

      if (row.completed) return 0;

      return this.twoDecimals(row.partial - this.getExecutedQuantity(row));
    },

    /**
     * Convierte el tipo de la fila a un string traducible
     */
    getTypeClass(row) {
      let classes = row.completed ? "completed " : "";
      if (this.isTask(row)) classes += "task";
      else {
        classes += "resource text-grey-darker ";
        if (row.completed) classes += "text-green";
        else if (parseFloat(row.executed_quantity) > parseFloat(row.total_units)) {
          classes += "text-red";
        }
      }
      return classes;
    },

    /**
     * Comprueba si hay errores en la ponderación
     */
    checkWeightingError() {
      if (this.listResources.length === 0 && this.listTasks.length === 0) return false; //la lista está vacía, ignoremos el error por ahora.

      //sumamos todos los pesos para comprobar si dan 100
      // weight puede llegar como string (DECIMAL de MySQL); hay que convertirlo o reduce concatena y toFixed falla
      this.weightingTasks = 0;
      if (this.listResources.length === 0 && this.listTasks.length > 0) {
        this.weightingTasks = this.sumWeights(this.listTasks).toFixed(5);
      }

      this.weightingResources = this.sumWeights(this.listResources).toFixed(5);

      return (parseFloat(this.weightingTasks) + parseFloat(this.weightingResources)) != 100;
    },

    sumWeights(list) {
      return (list || []).reduce((total, item) => {
        const weight = Number(item.weight);
        return total + (isNaN(weight) ? 0 : weight);
      }, 0);
    },

    formatWeight(weight) {
      const formatted = formatProjectFigure(weight, this.project);
      return formatted === '' ? formatProjectFigure(0, this.project) : formatted;
    },

    /**
     * Calcula el ratio (float de 0 a 1) de completado
     */
    getCompletionRate(row) {
      // las tareas valen 1 o 0
      if (this.isTask(row)) return row.completed;

      if (row.completed) return 1;

      // Es una tarea binaria  si no tiene un 0 como ejecutado siquiera
      if (this.isTask(row)) return 0;

      let rate = this.getExecutedQuantity(row) / row.partial;

      //El ratio no puede ser mayor que 1
      return rate > 1 ? 1 : rate;
    },

    /**
     * Comprueba si la fila dada tiene lineas en el histórico
     */
    hasLines(row) {
      if (!row.lines) return false;
      //Si puede o no mostrar lineas
      return row.lines.length ? true : false;
    },

    /**
     * Comprueba si la fila dada tiene lineas en el histórico
     */
    hasObservation(row) {
      if (!row.observation) return false;
      //Si puede o no mostrar lineas
      return true;
    },

    getExecutedQuantity(row) {
      let executed = row.parent_assignment_id ? row.executed_quantity : row.executed_quantity_sub
      return executed || 0;
    },

    getWeight(row) {
      return row.parent_assignment_id ? row.weightBc3 : row.weightBc3Sub
    },

    /**
     * @deprecated
     */
    openDetails(row, index) {
      //NOTA: Esta función es vestigial y ahora mismo no se usa, las lineas vienen precargadas
      //TODO: dejar de usar this.lines, para actualizar el assignment directamente
      if (typeof this.lines[row.id] === "undefined") {
        this.isLoading = true;
        let self = this;
        let url = "/api/v2/assignment/" + row.id;
        axios.get(url).then((response) => {
          if (response.data && response.data.success) {
            self.lines[row.id] = response.data.assignment.lines;
          }
          self.isLoading = false;
          self.openedSAssignmentId = row.id;
        });
      } else {
        this.isLoading = false;
        this.openedAssignmentId = row.id;
      }
    },

    /**
     * Abre el modal para añadir tarea
     */
    addTaskButtonClicked() {
      this.$refs.task_modal.show();
    },

    /**
     * Abre el modal para añadir medición
     */
    addResourceButtonClicked() {
      this.$refs.assignment_modal.show(null, this.listResources, {
        displayBoqRootMode: true,
      });
    },


    /**
     * Abre el modal para añadir medición
     */
    async addSubResource(assignment) {
      let childrencodes = assignment.children || [];
      // solo traemos si children no esta cargado ademas de children_count > 0
      if ((!assignment.children || assignment.children.length == 0) && assignment.children_count > 0){
        const result = await this.getChildrenAssignments('resource', false, assignment.id, true);
        if (result.data && result.data.assignments) {
          childrencodes = result.data.assignments;
        }
      }
      this.$refs.assignment_modal.show(assignment, childrencodes);
    },

    /**
     * Abre el modal para editar una medición
     */
    onClickEdit(assignment) {
      this.$refs.assignment_update_modal.show(assignment);
    },

        /**
     * Abre el modal para editar una medición
     */
    onClickTaskEdit(task) {
      this.$refs.task_update_modal.show(task);
    },

    onDeleteLine(assignmentLine, assignmentId) {
      this.$dialog.confirm({
        title: this.$t("delete"),
        message: this.$t("delete_assignment_line_confirm"),
        type: "is-danger",
        hasIcon: true,
        iconPack: "fas",
        icon: "trash-alt",
        confirmText: this.$t("delete"),
        cancelText: this.$t("cancel"),
        onConfirm: async () => {
          try {
            let url = "/api/v2/assignment/" + assignmentId + "/line/" + assignmentLine.id;
            const { data } = await axios.delete(url);

            if (data && data.success) {
              this.$toast.open({
                message: this.$t("success_deleting_generic"),
                type: "is-success",
                position: "is-top-right"
              });
              this.getList(ASSIGNMENT_CERTIFIER, true);
            } else {
              this.$toast.open({
                message: data.msg || this.$t("error_deleting_generic"),
                type: "is-danger",
                position: "is-top-right"
              });
            }
            this.getList(ASSIGNMENT_TASK, true);
            this.$emit("reload");
            EventBus.$emit("refreshActivityDocumentsNotifications", true);
          } catch (error) {
            this.$toast.open({
              message: this.$t("remove_error"),
              type: "is-danger",
              position: "is-top-right"
            });
          }

        },
      });
    },

    onNameClick(assignment, isActualProgress = false) {
      if (this.isTask(assignment)) return; // las tareas no tienen modal

      // this.$refs.assignment_contribute_modal.show(assignment.id); // comentamos, por que es reemplazado por contribute drawing
      this.$refs.assignment_contribute_drawing_modal.show(assignment.id, isActualProgress);
    },

    editResourcesButtonClicked() {
      if (!this.isEditing) {
        // copiamos la lista original para poder restaurarla en caso de cancelar
        this.originalListResources = JSON.parse(JSON.stringify(this.listResources));
        this.isEditing = true;
      } else {
        this.isEditing = false;
        this.listResources = JSON.parse(JSON.stringify(this.originalListResources));
        this.originalListResources = [];
        this.editedList = [];
      }
    },

    // Copiamos los valores editados para enviarlos al servidor
    onEditResource(assignment, field) {
      // Creamos un objeto con solo los campos necesarios
      if (!['weight', 'total_units'].includes(field)) {
        return;
      }
      const editedAssignment = {
        id: assignment.id,
        [field]: assignment[field],
      };

      // Buscamos si ya existe en la lista de editados
      let edited = this.editedList.find((item) => item.id === assignment.id);

      if (!edited) {
        this.editedList.push(editedAssignment);
      } else {
        edited[field] = assignment[field];
      }
    },

    onEditTask(task, field) {
      // Creamos un objeto con solo los campos necesarios
      if (!['name', 'weight'].includes(field)) {
        return;
      }
      const editedTask = {
        id: task.id,
        [field]: task[field],
      };
      // Buscamos si ya existe en la lista de editados
      let edited = this.editedTaskList.find((item) => item.id === task.id);
      if (!edited) {
        this.editedTaskList.push(editedTask);
      } else {
        edited[field] = task[field];
      }

    },

    distributeTaskWeights() {
      const total = 100
      const count = this.listTasks.length

      if (count === 0) return

      const weightScale = 100000 // assignments.weight es decimal(8, 5)
      const base = Math.floor((total / count) * weightScale) / weightScale
      let sum = 0

      for (let i = 0; i < count; i++) {
        const task = this.listTasks[i]
        if (i < count - 1) {
          task.weight = base
          sum += base
        } else {
          task.weight = Math.round((total - sum) * weightScale) / weightScale
        }

        // Reutiliza la lógica de edición
        this.onEditTask(task, 'weight')
      }
    },

    editTasksButtonClicked() {
      if (!this.isTaskEditing) {
        // copiamos la lista original para poder restaurarla en caso de cancelar
        this.originalListTasks = JSON.parse(JSON.stringify(this.listTasks));
        this.isTaskEditing = true;
      } else {
        this.isTaskEditing = false;
        this.listTasks = JSON.parse(JSON.stringify(this.originalListTasks));
        this.originalListTasks = [];
        this.editedTaskList = [];
      }
    },

    onClickValidate(assignment, assignmentLine = null) {
        this.$refs.assignment_validate_quantity_modal.show(assignment.id, assignmentLine);
      },

    // Doble check de calidad sobre cantidades ya validadas por inspección
    onClickValidateQuality(assignment) {
        this.$refs.assignment_validate_quantity_modal.show(assignment.id, null, true);
      },

    /**
     * Llamamos al modal de comentario
     */
    onCommentChanged(assignment) {
      this.$refs.assignment_comment_task_modal.show(assignment.id);
    },

    onEditLine(assignmentLine, assignment) {
      this.$refs.assignment_line_edit_modal.show(assignmentLine, assignment);
    },


    calculePonderation() {
      return parseFloat(this.sumWeights(this.listResources).toFixed(5));
    },

    calculeWeight() {
      return parseFloat(this.sumWeights(this.listTasks).toFixed(5));
    },

    onSaveEditedResources() {
      // primero comprobamos si la ponderación es correcta
      if (this.calculePonderation() !== 100.00) {
        return;
      }
      // verificamos si hay cambios
      if (this.editedList.length === 0) {
        this.isEditing = false;
        return;
      }
      this.editingLoading = true;
      let url = "/api/v2/assignments/edit/activity/" + this.entityId;
      const params = {
        assignment_resources: this.editedList,
      };
      axios.put(url, params)
        .then((response) => {
          if (response.data.success) {
            this.$toast.open({
              message: this.$t("save_successful"),
              type: "is-success",
              position: "is-top-right"
            });
            this.isEditing = false;
            this.editedList = [];
            this.getList(ASSIGNMENT_RESOURCE, true);
          } else {
            this.$toast.open({
              message: this.$t("error_saving"),
              type: "is-danger",
              position: "is-top-right"
            });
          }
          this.$emit("reload");
          this.editingLoading = false;
        })
        .catch(() => {
          this.$toast.open({
            message: this.$t("error_saving"),
            type: "is-danger",
            position: "is-top-right"
          });
          this.editingLoading = false;
        });
    },

    saveTasksButtonClicked() {
      // primero comprobamos si la ponderación es correcta
      if (this.calculeWeight() !== 100.00) {
        return;
      }
      // verificamos si hay cambios
      if (this.editedTaskList.length === 0) {
        this.isTaskEditing = false;
        return;
      }
      this.editingLoading = true;
      let url = "/api/v2/assignments/edit/activity/" + this.entityId;
      const params = {
        assignment_resources: this.editedTaskList,
      };
      axios.put(url, params)
        .then((response) => {
          if (response.data.success) {
            this.$toast.open({
              message: this.$t("save_successful"),
              type: "is-success",
              position: "is-top-right"
            });
            this.isTaskEditing = false;
            this.editedTaskList = [];
            this.getList(ASSIGNMENT_TASK, true);
          } else {
            this.$toast.open({
              message: this.$t("error_saving"),
              type: "is-danger",
              position: "is-top-right"
            });
          }
          this.editingLoading = false;
          this.$emit("reload");
        })
        .catch(() => {
          this.$toast.open({
            message: this.$t("error_saving"),
            type: "is-danger",
            position: "is-top-right"
          });
          this.editingLoading = false;
        });
    },


    annulAction(line, assignmentId) {

      this.$dialog.confirm({
        title: this.$t("delete"),
        message: this.$t("delete_generic", ['la ejecución '+line.executed_quantity]),
        confirmText: this.$t("delete"),
        type: "is-danger",
        hasIcon: true,
        onConfirm: async () => {
          this.isLoading = true;
          let url = `/api/v2/assignment/${assignmentId}/line/${line.id}`;
          const { data } = await axios.delete(url);

          if (data.success) {
            this.$toast.open({
              message: this.$t("removed_successfully"),
              type: "is-success",
              position: "is-top-right"
            });

            this.getList(ASSIGNMENT_RESOURCE, true); // recargar lista mediciones
            this.$emit("reload"); // recalcular progreso actividad

          } else {
            // Error
            this.$toast.open({
              message: data.msg || this.$t("remove_error"),
              type: "is-danger",
              position: "is-top-right"
            });
          }
          this.isLoading = false;
        }
      });
    },

    /**
     * Llamamos al modal de completar
     */
    onCompleteChanged(assignment) {
      // if (this.user.collaborator != 1) { Colaboradores tambien pueden completar
        this.$refs.assignment_completed_modal.show(assignment.id, assignment.completed);
      // }
    },

    calculateProgress(weight, executed_quantity) {
      if (!weight || weight === 0) return 0; // evita división por cero
      return (executed_quantity / weight) * 100;
    },

    /**
     * Llamamos al modal de registro de tareas
    */
    onRegisterTask(assignment, isReal=false, actionType = 1) {
      this.$refs.assignment_register_task_modal.show(assignment, isReal, actionType);
    },

    /**
     * Carga la lineas de una medición en concreto
     * @deprecated Debido a que estamos cargando las lineas junto a las mediciones
     */
    loadLines(assignment) {
      let url = "/api/v2/assignment/" + assignment.id;
      let args = {
        withLines: 1,
      };
      self = this;
      axios
        .get(url, { params: args })
        .then(function (response) {
          assignment.lines = response.data.assignment.lines;
        })
        .catch((error) => {
          self.$notify.error("update_error");
        });
    },

    /**
     * Cantidad o avance con los decimales del proyecto (2 o 4).
     */
    twoDecimals(number) {
      const formatted = formatProjectFigure(number, this.project);
      return formatted === '' ? formatProjectFigure(0, this.project) : formatted;
    },

    calculateCertifierValues(item, type='pending'){

      if (item.lines) {
        if (type == 'pending')
          return ((item.total_quantity - item.executed_quantity) == 0)
          ? (item.total_quantity - item.executed_quantity).toFixed()
          : formatProjectFigure(item.total_quantity - item.executed_quantity, this.project)

        const executed = formatProjectFigure(item.executed_quantity, this.project)
        return (item.executed_quantity == null || item.executed_quantity == 0) ? 0 : executed

      }

      return type == 'pending' ? item.total_units : 0;

    },

    // bloquea/desbloquea manipular las mediciones certificadoras
    async onClickUnlockMeasurementsButton() {
      const { data } = await axios.post('/api/v2/activity/' + this.activityId + '/blockedAssignments', { blocked: !this.assignmentsLocked })
      if (data && data.success) {
        this.assignmentsLocked = !this.assignmentsLocked;
        this.$notify.success(this.assignmentsLocked ? 'success_updating_blocked_assignments' : 'success_updating_unblocked_assignments')
      } else {
        this.$notify.error('error_updating_blocked_assignments')
      }
    },

    isImage(extension) {
      let valid_extensions = ['png', 'jpg', 'jpeg']
      return valid_extensions.includes(extension)
    },

    loadAssignments(type, force_load) {
      if( type === ASSIGNMENT_RESOURCE )
        return force_load ? true : (!this.isLoadingResource && this.listResources.length == 0);

      if( type === ASSIGNMENT_TASK )
        return force_load ? true : (!this.isLoadingTask && this.listTasks.length == 0);

      if( type === ASSIGNMENT_CERTIFIER )
        return force_load ? true : (!this.isLoadingCertifier && this.listCertifiers.length == 0);

      if( type === ASSIGNMENT_CERTIFIER_HEAD )
        return force_load ? true : (!this.isLoadingCertifierHead && this.listChapters.length == 0);
    },

    stateLoading(type, state) {
      if( type === ASSIGNMENT_RESOURCE )
        this.isLoadingResource = state;

      if( type === ASSIGNMENT_TASK )
        this.isLoadingTask = state;

      if( type === ASSIGNMENT_CERTIFIER )
        this.isLoadingCertifier = state;

      if( type === ASSIGNMENT_CERTIFIER_HEAD )
        this.isLoadingCertifierHead = state;
    },

    getNameOrCodePartner(partners) {
      if (partners.length == 0)
        return 'Orden pedido sin asignar'

      // de momento solo consideramos al primer partner
      return partners[0].code ? partners[0].code : partners[0].name
    },

    getTotalQuantity(assignment) {
      return assignment.total || assignment.total_quantity || 0
    },

    /**
     * Cantidades con los decimales del proyecto (2 o 4).
     */
    formatAssignmentQuantity(value, assignment) {
      const number = Number(value)
      if (!Number.isFinite(number)) {
        return '0'
      }
      if (number === 0) {
        return '0'
      }
      return number.toLocaleString('es-ES', {
        minimumFractionDigits: 0,
        maximumFractionDigits: quantityDisplayDecimals(this.project),
      })
    },

    formatTotalDisplay(assignment) {
      return this.formatAssignmentQuantity(this.getTotalQuantity(assignment), assignment)
    },

    formatExecutedDisplay(assignment, field = 'executed_quantity') {
      const executed = assignment && assignment[field]
      if (executed == null || executed === '' || Number(executed) === 0) {
        return '0'
      }
      return this.formatAssignmentQuantity(executed, assignment)
    },

    formatPendingDisplay(assignment, executedField = 'executed_quantity') {
      const total = parseFloat(this.getTotalQuantity(assignment)) || 0
      const executed = parseFloat(assignment && assignment[executedField]) || 0
      return this.formatAssignmentQuantity(total - executed, assignment)
    },

    onShowFullWidth(payload) {
      this.lastActiveTab = this.mainActiveTab;
          this.$emit('ActivityHomeShowFullWidth', {
            ...payload,
            view: 1
          });
    },

    selectKpiTab() {
      const tabs = Array.from(this.$el.querySelectorAll('.b-tabs .tab, .b-tabs .tab-item'));
      const kpiIndex = tabs.findIndex(tab => tab.textContent.trim().toLowerCase().includes('kpis'));
      if (kpiIndex !== -1) {
        this.mainActiveTab = kpiIndex;
      }
    },

    hideHistoryLines() {
      return this.company.alias == 'welink' && this.user.collaborator == 1
    }
  },
};
</script>
<style>
.table-assignments.b-table .table .chevron-cell {
  padding-right: 0;
  padding-left: 2px;
}

.table-assignments.b-table thead tr th {
  padding: 4px;
}

.table-assignments thead tr th .th-wrap {
  color: #606f7b;
}

.table-assignments tbody tr td.vertical-center {
  vertical-align: middle;
}

.table-assignments tbody:nth-child(even) {
  background-color: #dfebf5;
  border-radius: 3px;
}

.task.completed span {
  background-color: #7ba7cc !important;
}

td.type-column.resource span {
  color: inherit;
}
</style>

<style scoped>
.is-clickable:hover {
  cursor: pointer;
}

.table-assignments >>> * {
  border: none;
}

.table-assignments >>> th {
  background-color: transparent;
  border-bottom: 1px lightgray solid;
}

.table.is-narrow td,
.table.is-narrow th {
  padding: 0.25em 0.25em;
}

/* Solo las tareas usan la pelotita */
td.type-column.task >>> span {
  margin: auto;
  display: block;

  height: 2.5rem;
  line-height: 2.5rem;
  width: 2.5rem;
  font-weight: 600;
  font-size: 1.15rem;
  background-color: #b8c2cc;
  color: white;

  overflow: visible;
  border-radius: 9999px;
}

td.task.type-column {
  vertical-align: middle;
  padding: 0.25em;
  height: 2.5rem;
  width: 2.5rem;
}
</style>
